import * as React from 'react'
import MenuItem from '@mui/material/MenuItem'
import { ListItemIcon, ListItemText, Select, SelectChangeEvent, Typography } from '@mui/material'
import { memberKind } from '../internalModules'
import { dialogTypographyStyle, rowHeight } from '../Graphics'
import UIMemberIcon from './UIMemberIcon'

type Props = {
  label: string
  kind: string
  handleChange: ((event: SelectChangeEvent<string>, child: React.ReactNode) => void) | undefined
  memberClassFilter?: string[]
}

export default function UISelectMemberClass( {label, kind, handleChange, memberClassFilter = []}: Props ) {
  return (
    <>
      <Typography sx={dialogTypographyStyle} color='secondary'>{label}</Typography>
      <Select
        size='small'
        style={{height: 42}}
        SelectDisplayProps={{ style: {display: 'flex', alignItems: 'center'} }}
        fullWidth
        labelId='member-select-label'
        value={kind}
        name='kind'
        onChange={handleChange}
      >
        {Object.values(memberKind).map(m => (
            <MenuItem key={m} value={m}>
                <ListItemIcon>
                  <UIMemberIcon kind={m}/>
                </ListItemIcon>
                <ListItemText sx={{paddingLeft: 2}}>{m}</ListItemText>
            </MenuItem>          
          ))
        }
      </Select>
    </>  
  )

}